export default __webpack_public_path__ + "static/media/calendar-a.2ab76589.svg";